import { useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay"
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal"
import { useModal } from "../../contexts/ModalContext";

import useApi from "../../hooks/useApi";
const ModalNewGHE = ({ id, ghe, onSuccess }) => {
    const api = useApi();


    const { closeModal } = useModal();

    const [ loading, setLoading ] = useState( false );
    const [ nomeGhe, setNomeGhe ] = useState( ghe ?? "");

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        if( !nomeGhe.trim() ){

            alert("O GHE não pode estar vazio.");
            return;

        }

        setLoading( true );

        try{

            const formData = new FormData();
            formData.append('ghe', nomeGhe )
            if( id ){

                formData.append( 'id', id );

            }

            const url = "/Painel/API/InfoPanel/EditGhe/"

            const { data } = await api.post( url, formData, { withCredentials: true } );
            console.log( data );
            await onSuccess();

        }catch( e ){

            console.log( e );

        }finally{

            setLoading(false);

        }

    }

    return (
        <>
            <Overlay state={ true } >
                <Modal header={ true } close={ closeModal } >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="NOME GHE"
                            type="text"
                            required
                            valor={ nomeGhe }
                            changeFunc={ (e) => setNomeGhe( e.target.value.toUpperCase() ) }
                            disabled={ loading }
                        />
                        <FormComp
                            type="submit"
                            valor={ loading ? "SALVANDO..." : "SALVAR" }
                            disabled={ loading }
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )

}

export default ModalNewGHE;